import { useEffect, useState } from 'react'

import { useAspirantsApi } from '@/services/api/aspirantsApi'
import { useAuthStore } from '@/store/authStore'
import { ErrorHandlingStrategy, MessageLevel } from '@/types/api'

/**
 * Hook que precarga isMinor del aspirante para evitar demoras de render.
 */
export function useMinorStatusLoader() {
    const { isAuthenticated, idAspirant, isMinor, updateIsMinor } =
        useAuthStore()
    const [hasLoadedIsMinor, setHasLoadedIsMinor] = useState(false)

    const aspirantsApi = useAspirantsApi({
        messageLevel: MessageLevel.ERRORS,
        errorHandling: ErrorHandlingStrategy.RETURN
    })

    useEffect(() => {
        if (!isAuthenticated || !idAspirant || hasLoadedIsMinor) {
            return
        }

        if (isMinor !== null && isMinor !== undefined) {
            setHasLoadedIsMinor(true)
            return
        }

        const loadIsMinor = async () => {
            try {
                const { data, status } =
                    await aspirantsApi.getBasicData(idAspirant)

                if (status === 200 && data?.isMinor !== undefined) {
                    updateIsMinor(data.isMinor ?? null)
                }
                setHasLoadedIsMinor(true)
            } catch (error) {
                if (process.env.NODE_ENV === 'development') {
                    console.error('[MinorStatusLoader] Error al cargar:', error)
                }
            }
        }

        loadIsMinor()
    }, [
        isAuthenticated,
        idAspirant,
        hasLoadedIsMinor,
        isMinor,
        aspirantsApi,
        updateIsMinor
    ])

    useEffect(() => {
        if (!isAuthenticated && hasLoadedIsMinor) {
            setHasLoadedIsMinor(false)
        }
    }, [isAuthenticated, hasLoadedIsMinor])

    return {
        isMinor,
        isLoading: !hasLoadedIsMinor,
        hasLoaded: hasLoadedIsMinor
    }
}
